import { useRef, useState } from 'react';
/** The optional controlled form keeps standalone consumers backwards compatible. */
export function useCashUiContext(initial, context, onContext) {
    const [local, setLocal] = useState(initial);
    const value = context ?? local;
    const latest = useRef(value);
    latest.current = value;
    const set = (key, next) => {
        const updated = { ...latest.current, [key]: next };
        latest.current = updated;
        if (onContext)
            onContext(updated);
        else
            setLocal(updated);
    };
    return [value, set];
}
/** Retired directory frames resolve to the canonical read screen, while document tasks stay intact. */
export function normalizeCashCounterpartyNavigation(value, canRead) {
    if (!canRead || value.detail)
        return value;
    if (value.view === 'settlements' && value.settlements?.selected?.kind === 'party' && value.settlements.selected.id.startsWith('receivable:') && value.settlements.direction === 'ALL')
        return { ...value, settlements: { ...value.settlements, direction: 'RECEIVABLE' } };
    const purchase = value.view === 'purchases' ? value.purchases : undefined;
    const management = value.view === 'management' ? value.management : undefined;
    const selected = purchase?.selected || management?.selected;
    const directory = purchase && (selected ? selected.kind === 'party' || selected.kind === 'receivable' : purchase.tab !== 'purchases') || management && (selected ? selected.kind === 'counterparty' : management.advanced && management.area === 'counterparties');
    if (!directory)
        return value;
    const id = selected && selected.kind !== 'basis' ? `${selected.kind === 'receivable' ? 'receivable' : 'counterparty'}:${selected.id}` : undefined;
    return { ...value, view: 'settlements', detail: null, settlements: { search: purchase?.search || '', currency: purchase?.currency || management?.currency || '', direction: selected?.kind === 'receivable' ? 'RECEIVABLE' : purchase && !selected ? purchase.tab === 'receivables' ? 'RECEIVABLE' : 'PAYABLE' : 'ALL', partyStatus: 'ACTIVE', historyFrom: '', historyTo: '', selected: id ? { kind: 'party', id } : null } };
}
